import {
  MALTA_FULL_TIME_FEE_VISIBILITY_FIELD,
  type MaltaFullTimeFeeLineKey,
  type MaltaFullTimeFeeVisibility,
} from "@/src/constants/AdmissionOffice/Malta/maltaFullTimeAdmissionConfig";

export const FORM_OF_EDUCATION_DEFAULT = "Default";

export const SHENGEN_FORM_OF_EDUCATION_LABELS = [FORM_OF_EDUCATION_DEFAULT] as const;

export type ShengenDefaultFeeLineKey =
  | "tuitionFee"
  | "admissionFee"
  | "otherExpenses"
  | "transfer"
  | "certificationEqualization"
  | "preparatoryDepartment";

export type ShengenDefaultFeeVisibility = Record<ShengenDefaultFeeLineKey, boolean>;

export const SHENGEN_DEFAULT_FEE_LINE_ORDER: ShengenDefaultFeeLineKey[] = [
  "tuitionFee",
  "preparatoryDepartment",
  "admissionFee",
  "otherExpenses",
  "transfer",
  "certificationEqualization",
];

export const SHENGEN_DEFAULT_FEE_LINE_SUFFIXES: Record<ShengenDefaultFeeLineKey, string> = {
  tuitionFee: " EUR (per year)",
  admissionFee: " EUR one-time payment",
  otherExpenses: " EUR first year only",
  transfer: " EUR (first year only)",
  certificationEqualization: " EUR (first year only)",
  preparatoryDepartment: " EUR (per year)",
};

export const SHENGEN_DEFAULT_FEE_LINE_LABELS: Record<ShengenDefaultFeeLineKey, string> = {
  tuitionFee: "Tuition Fee",
  admissionFee: "Admission Fee",
  otherExpenses: "Other Expenses (Administrative Fee, Registration Fee, etc.)",
  transfer: "Transfer Charges",
  certificationEqualization: "Certification and Equalization of all documents",
  preparatoryDepartment: "Preparatory Department",
};

export const formatShengenDefaultFeeLineDisplay = (key: ShengenDefaultFeeLineKey, numericValue?: string) => {
  const trimmed = numericValue?.trim();
  if (!trimmed) return "";
  return `${trimmed}${SHENGEN_DEFAULT_FEE_LINE_SUFFIXES[key]}`;
};

export const SHENGEN_DEFAULT_STATIC_ADMISSION_PARAGRAPH =
  "This Admission Letter confirms your eligibility to study in Schengen University. To continue the admission process and to enroll to the university, you need to cover the complete first year fee. After the payment is received you will be officially accepted to the university and provided with your personal Student\u2019s Office. There you will have an access to your personalized curriculum, all the educational materials, lectures, textbooks, etc. The classes will be provided according to your schedule and curriculum.";

/** Defaults match the Schengen Distance-style letter from the design screenshot. */
export const SHENGEN_DEFAULT_FEE_VISIBILITY: MaltaFullTimeFeeVisibility = {
  tuitionFee: true,
  acommodation: false,
  medicalInsurance: false,
  residencePermit: false,
  admissionFee: true,
  otherExpenses: true,
  transfer: true,
  certificationEqualization: false,
  preparatoryDepartment: false,
  completeOneYear: true,
};

export const SHENGEN_DEFAULT_FEE_VALUES: Record<MaltaFullTimeFeeLineKey, string> = {
  tuitionFee: "6 000",
  acommodation: "",
  medicalInsurance: "",
  residencePermit: "",
  admissionFee: "1 000",
  otherExpenses: "400",
  transfer: "3 000",
  certificationEqualization: "",
  preparatoryDepartment: "",
  completeOneYear: "",
};

type SetShengenDefaultFormValue = (
  name: string,
  value: string | boolean,
  options?: { shouldDirty?: boolean },
) => void;

export const applyShengenDefaultFormDefaults = (setValue: SetShengenDefaultFormValue): void => {
  setValue("formOfEducation", FORM_OF_EDUCATION_DEFAULT, { shouldDirty: false });

  (Object.entries(SHENGEN_DEFAULT_FEE_VALUES) as Array<[MaltaFullTimeFeeLineKey, string]>).forEach(
    ([key, value]) => {
      setValue(key, value, { shouldDirty: false });
    },
  );

  (Object.entries(SHENGEN_DEFAULT_FEE_VISIBILITY) as Array<[MaltaFullTimeFeeLineKey, boolean]>).forEach(
    ([key, visible]) => {
      setValue(MALTA_FULL_TIME_FEE_VISIBILITY_FIELD[key], visible, { shouldDirty: false });
    },
  );

  setValue("showSecondYear", false, { shouldDirty: false });
};
